export default __webpack_public_path__ + "static/media/image-1.2bc3e39c.webp";